/* GENERATED FROM usagemanager.proto. DO NOT EDIT MANUALLY. */
/* tslint:disabled */
/* eslint-disable */

import {
  APIRequest,
  APIResponse,
  makeRequest,
  preProcessingResponse
} from '../'
import * as base from './base.service'
import * as commonHdr from './commonHdr.service'

export class Usagemanager {
  static OnboardAccounts = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<ScanCloudEventsRequest, {}, ScanCloudEventsResponse>): Promise<
    APIResponse<ScanCloudEventsResponse>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/usage/onboardaccounts`,
      method: 'POST',
      reqOptions: {
        body: JSON.stringify(params),
        ...options
      }
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<ScanCloudEventsResponse>>()
          .then<APIResponse<ScanCloudEventsResponse>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetUserLocationData = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<UserLocationReq, {}, UserLocationResp>): Promise<
    APIResponse<UserLocationResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/usage/user-location`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<UserLocationResp>>()
          .then<APIResponse<UserLocationResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetUsageData = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<UsageReq, {}, commonHdr.UsageResp>): Promise<
    APIResponse<commonHdr.UsageResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/usage/usage`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<commonHdr.UsageResp>>()
          .then<APIResponse<commonHdr.UsageResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })

  static GetUsageEventRaw = ({
    params,
    options,
    makeRequestOptions
  }: APIRequest<GetEventRawReq, {}, GetEventRawResp>): Promise<
    APIResponse<GetEventRawResp>
  > =>
    makeRequest({
      ...makeRequestOptions,
      port: '',
      url: `/v1/usage/eventraw`,
      method: 'GET',
      reqOptions: options,
      params
    }).then((res: Response) => {
      try {
        return res
          .json<APIResponse<GetEventRawResp>>()
          .then<APIResponse<GetEventRawResp>>(preProcessingResponse)
          .catch(ex => Promise.reject(res))
      } catch (ex) {
        return Promise.reject(res)
      }
    })
}

export interface CreateTenantRequest {
  req_hdr?: base.ReqHdr
  tenant_id?: string
}

export interface CreateTenantResponse {
  resp_hdr?: base.RespHdr
}

export interface UpdateGraphDBRequest {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  account_id?: string
}

export interface UpdateGraphDBResponse {
  resp_hdr?: base.RespHdr
}

export interface RemediateReq {
  req_hdr?: base.ReqHdr
  identity_uri?: string
  role_uri?: string
  actions?: string[]
  revoke?: boolean
}

export interface RemediateResp {
  resp_hdr?: base.RespHdr
}

export interface UserLocationReq {
  req_hdr?: base.ReqHdr
  username?: string
  account_id?: string
}

export interface UserLocationResp {
  resp_hdr?: base.RespHdr
  userlocationmap?: UserLocationResp_UserlocationmapEntry
}

export interface UserLocationResp_UserlocationmapEntry {
  [key: string]: UserLocationData
}

export interface UserLocationData {
  locationdata?: LocationData[]
}

export interface LocationData {
  city?: string
  state?: string
  country?: string
  coordinates?: commonHdr.coordinates
  radius?: number
}

export interface QueueReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  add?: boolean
}

export interface QueueResp {
  resp_hdr?: base.RespHdr
}

export interface Attribute {
  mfaAuthenticated?: string
  creationDate?: string
}

export interface SessionContext {
  attributes?: Attribute
  sessionIssuer?: SessionIssuer
}

export interface UserIdentity {
  type?: string
  principalId?: string
  arn?: string
  accountId?: string
  accessKeyId?: string
  userName?: string
  sessionContext?: SessionContext
  invokedBy?: string
}

export interface SessionIssuer {
  type?: string
  principalId?: string
  arn?: string
  accountId?: string
  userName?: string
}

export interface Items {
  instanceId?: string
}

export interface IamInstanceProfile {
  Id?: string
  Arn?: string
}

export interface IamInstanceProfileAssociation {
  InstanceId?: string
  State?: string
  AssociationId?: string
  InstanceProfile?: IamInstanceProfile
}

export interface iamInstanceProfileAssociations {
  InstanceProfileAssn?: IamInstanceProfileAssociation[]
}

export interface Instance {
  instanceId?: string
}

export interface InstancesSet {
  items?: Items[]
}

export interface InstanceId {
  content?: string
}

export interface DescribeInstanceCreditSpecificationsRequest {
  InstanceId?: InstanceId
}

export interface InstanceCreditSpecification {
  cpuCredits?: string
  InstanceId?: string
}

export interface RequestParameters {
  principalArn?: string
  roleSessionName?: string
  roleArn?: string
  bucketName?: string
  key?: string
  groupName?: string
  groupDescription?: string
  vpcId?: string
  groupId?: string
  subnetId?: string
  instanceId?: string
  instancesSet?: InstancesSet
  DICreditSpecReq?: DescribeInstanceCreditSpecificationsRequest
  InstanceCredSpecs?: InstanceCreditSpecification[]
  IamInstanceProfileAssociation?: IamInstanceProfileAssociation
  functionName?: string
  resource?: string
  resourcesSet?: ResourcesSet
  DescribeInstanceCreditSpecificationsRequest?: DescribeInstanceCreditSpecificationsRequest
  AssociateIamInstanceProfileRequest?: IamInstanceProfileAssociation
  dBClusterIdentifier?: string
  tags?: Tag[]
  CreateVpcEndpointRequest?: CreateVpcEndpointRequest
  ModifyVpcEndpointRequest?: ModifyVpcEndpointRequest
  DeleteVpcEndpointsRequest?: DeleteVpcEndpointsRequest
  dBInstanceIdentifier?: string
  DescribeVpcEndpointConnectionNotificationsRequest?: DescribeVpcEndpointConnectionNotificationsRequest
  CreateVpcEndpointConnectionNotificationRequest?: CreateVpcEndpointConnectionNotificationRequest
  CreateVpcEndpointServiceConfigurationRequest?: CreateVpcEndpointServiceConfigurationRequest
  loadBalancerArn?: string
  resourceArns?: string[]
  AcceptVpcEndpointConnectionsRequest?: AcceptVpcEndpointConnectionsRequest
  DeleteVpcEndpointServiceConfigurationsRequest?: DeleteVpcEndpointServiceConfigurationsRequest
  ModifyVpcEndpointServiceConfiguration?: ModifyVpcEndpointServiceConfiguration
  DescribeVpcEndpointServicePermissionsRequest?: DescribeVpcEndpointServicePermissionsRequest
  ModifyVpcEndpointConnectionNotificationRequest?: ModifyVpcEndpointConnectionNotificationRequest
  ModifyVpcEndpointServicePermissionsRequest?: ModifyVpcEndpointServicePermissionsRequest
  RejectVpcEndpointConnectionsRequest?: RejectVpcEndpointConnectionsRequest
  resourceName?: string
  sourceIds?: string[]
  sourceIdentifier?: string
  loadBalancerName?: string
  LoadBalancerNames?: string[]
}

export interface RejectVpcEndpointConnectionsRequest {
  VpcEndpointId?: VpcEndpointId
}

export interface ModifyVpcEndpointServicePermissionsRequest {
  ServiceId?: string
}

export interface ModifyVpcEndpointConnectionNotificationRequest {
  ConnectionNotificationId?: string
}

export interface DescribeVpcEndpointServicePermissionsRequest {
  ServiceId?: string
}

export interface ModifyVpcEndpointServiceConfiguration {
  ServiceId?: string
}

export interface DeleteVpcEndpointServiceConfigurationsRequest {
  ServiceId?: ServiceId
}

export interface ServiceId {
  tag?: number
  content?: string
}

export interface AcceptVpcEndpointConnectionsRequest {
  VpcEndpointId?: VpcEndpointId
}

export interface Tag {
  value?: string
  key?: string
}

export interface CreateVpcEndpointRequest {
  VpcId?: string
}

export interface DeleteVpcEndpointsRequest {
  VpcEndpointId?: VpcEndpointId
}

export interface VpcEndpointId {
  tag?: number
  content?: string
}

export interface ModifyVpcEndpointRequest {
  VpcEndpointId?: string
}

export interface DescribeVpcEndpointConnectionNotificationsRequest {
  Filter?: Filter
}

export interface Filter {
  Value?: Value
  tag?: number
  Name?: string
}

export interface Value {
  tag?: number
  content?: string
}

export interface CreateVpcEndpointConnectionNotificationRequest {
  VpcEndpointId?: string
}

export interface CreateVpcEndpointServiceConfigurationRequest {
  NetworkLoadBalancerArn?: NetworkLoadBalancerArn
}

export interface NetworkLoadBalancerArn {
  tag?: number
  content?: string
}

export interface ResourcesSet {
  items?: Item[]
}

export interface Item {
  resourceId?: string
}

export interface Resource {
  arn?: string
  accountId?: string
  type?: string
}

export interface AssumedRoleUser {
  arn?: string
}

export interface Subnet {
  subnetId?: string
  subnetArn?: string
}

export interface Vpc {
  vpcId?: string
}

export interface ResponseElements {
  assumedRoleUser?: AssumedRoleUser
  groupId?: string
  subnet?: Subnet
  vpc?: Vpc
  instanceId?: string
  instancesSet?: InstancesSet
  InstanceProfileAssns?: IamInstanceProfileAssociation[]
  credentials?: Credentials
  dBClusterIdentifier?: string
  dBClusterMembers?: dBClusterMembers[]
  loadBalancers?: loadBalancers[]
}

export interface loadBalancers {
  loadBalancerName?: string
}

export interface dBClusterMembers {
  dBInstanceIdentifier?: string
}

export interface CloudTrailEvent {
  eventVersion?: string
  userIdentity?: UserIdentity
  eventTime?: string
  eventSource?: string
  eventName?: string
  awsRegion?: string
  sourceIpAddress?: string
  userAgent?: string
  errorCode?: string
  errorMessage?: string
  requestParameters?: RequestParameters
  responseElements?: ResponseElements
  requestId?: string
  eventId?: string
  resources?: Resource[]
  eventType?: string
  recipientAccountId?: string
  unparsed_event?: string
}

export interface Events {
  Records?: CloudTrailEvent[]
}

export interface UsageReq {
  req_hdr?: base.ReqHdr
  username?: string
  account_id?: string
  table_options?: commonHdr.ServerTableReq
  start_time?: string
  end_time?: string
}

export interface GetEventRawReq {
  req_hdr?: base.ReqHdr
  event_id?: string
}

export interface GetEventRawResp {
  resp_hdr?: base.RespHdr
  unparsed_event?: string
}

export interface SensitivePrivsReq {
  req_hdr?: base.ReqHdr
  summary?: boolean
  identity_uri?: string
  role_uri?: string
  revoked?: boolean
  account_id?: string
}

export interface UserUnusedPrivsInfo {
  name?: string
  URI?: string
  account_id?: string
  count?: string
  type?: string
}

export interface Credentials {
  accessKeyId?: string
}

export interface SensitivePrivsResp {
  resp_hdr?: base.RespHdr
  user_info?: UserUnusedPrivsInfo[]
  actions?: string[]
  allow_remediation?: boolean
}

export interface AzureEvents {
  req_hdr?: base.ReqHdr
  records?: AzureRecords[]
}

export interface ProcessAzureEventHubLogsResp {
  resp_hdr?: base.RespHdr
}

export interface Evidence {
  role?: string
}

export interface Authorization {
  scope?: string
  action?: string
  evidence?: Evidence
}

export interface Claims {
  aud?: string
  iss?: string
  iat?: string
  nbf?: string
  exp?: string
  authnclassreference?: string
  aio?: string
  altsecid?: string
  authnmethodsreferences?: string
  appid?: string
  appidacr?: string
  emailaddress?: string
  surname?: string
  givenname?: string
  groups?: string
  identityprovider?: string
  ipaddr?: string
  name?: string
  objectidentifier?: string
  puid?: string
  scope?: string
  nameidentifier?: string
  tenantid?: string
  identityclaimsname?: string
  uti?: string
  ver?: string
  wids?: string
}

export interface Identity {
  authorization?: Authorization
  claims?: Claims
}

export interface AzureRecords {
  time?: string
  resourceId?: string
  operationName?: string
  category?: string
  resultType?: string
  resultSignature?: string
  durationMs?: string
  callerIpAddress?: string
  correlationId?: string
  identity?: Identity
  level?: string
  location?: string
  properties?: AzureRecords_PropertiesEntry
  unparsed_event?: string
}

export interface AzureRecords_PropertiesEntry {
  [key: string]: string
}

export interface ScanCloudEventsRequest {
  request_header?: base.ReqHdr
  tenant_id?: string
  account_info?: base.AccountInfo
  startTime?: string
  endTime?: string
  onboarding_done?: boolean
}

export interface ScanCloudEventsResponse {
  response_header?: base.RespHdr
}

export interface DailyAccountCleanupReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  account_id?: string
}

export interface DailyUsageCleanupReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
}

export interface CreateOrDeleteAccountReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
  delete_topic_arns?: string[]
  add_topic_arns?: string[]
  add_accounts?: base.AccountInfo[]
  delete_accounts?: base.AccountInfo[]
}

export interface EventsUploadReq {
  req_hdr?: base.ReqHdr
  tenant_id?: string
}

export enum DayIntervalEnum {
  Zero = 'Zero',
  One = 'One',
  Seven = 'Seven',
  Thirty = 'Thirty',
  Sixty = 'Sixty',
  Ninety = 'Ninety'
}

export enum OnboardingStatusEnum {
  INIT = 'INIT',
  PULL_DONE = 'PULL_DONE',
  DAILY_UPDATE = 'DAILY_UPDATE'
}
